






















































































import {
  defineComponent,
  ref,
  Ref,
  onMounted,
  watch,
} from '@vue/composition-api';
import { DataTableHeader } from 'vuetify';
import sl from '@/serviceLocator';
import OareContentView from '@/components/base/OareContentView.vue';
import { SignList } from '@oare/types';
import _ from 'lodash';

export interface OareDataTableOptions {
  page: number;
  rows: number;
  sortBy: string;
  sortDesc: boolean;
}

export default defineComponent({
  components: { OareContentView },
  name: 'SignListView',
  props: {},
  setup() {
    const server = sl.get('serverProxy');
    const actions = sl.get('globalActions');
    const loading = ref(false);
    const sortByOptions = ['Name', 'ABZ', 'MZL', 'Frequency'];
    const sortBy = ref('name');
    const allSigns = ref('false');
    const search = ref('');
    const tableHeaders: Ref<DataTableHeader[]> = ref([
      {
        text: 'Sign',
        value: 'code',
        width: '16%',
        sortable: false,
      },
      {
        text: 'Name',
        value: 'name',
        width: '16%',
        sortable: false,
      },
      {
        text: 'ABZ',
        value: 'abz',
        width: '8%',
        sortable: false,
      },
      {
        text: 'MZL',
        value: 'mzl',
        width: '8%',
        sortable: false,
      },
      {
        text: 'Frequency',
        value: 'frequency',
        width: '16%',
        sortable: false,
      },
      {
        text: 'Readings',
        value: 'readings',
        width: '32%',
        sortable: false,
      },
    ]);

    const items: Ref<SignList[]> = ref([]);
    const filteredItems: Ref<SignList[]> = ref([]);

    const getWidth = (src: string) => {
      const image = new Image();
      image.src = src;
      const heightRatio = 25 / image.height;
      return heightRatio * image.width;
    };

    const getSignHTMLCode = (code: string) => {
      const codeArray: string[] = code.split('+');
      let finishedCodeArray: string[] = [];
      codeArray.forEach(c => {
        let codePt = Number(`0x${c}`);
        if (codePt > 0xffff) {
          codePt -= 0x10000;
          finishedCodeArray.push(
            String.fromCharCode(
              0xd800 + (codePt >> 10),
              0xdc00 + (codePt & 0x3ff)
            )
          );
        } else {
          finishedCodeArray.push(String.fromCharCode(codePt));
        }
      });
      return finishedCodeArray.join('');
    };

    const filterSigns = () => {
      filteredItems.value = items.value.filter(
        item =>
          item.abz
            ?.toLocaleLowerCase()
            .includes(search.value.toLocaleLowerCase()) ||
          `${item.frequency}`
            .toLocaleLowerCase()
            .includes(search.value.toLocaleLowerCase()) ||
          `${item.mzl}`
            .toLocaleLowerCase()
            .includes(search.value.toLocaleLowerCase()) ||
          item.name
            .toLocaleLowerCase()
            .includes(search.value.toLocaleLowerCase()) ||
          item.readings
            ?.toLocaleLowerCase()
            .includes(search.value.toLocaleLowerCase())
      );
    };

    const getSigns = async () => {
      loading.value = true;
      items.value = [];
      filteredItems.value = [];
      try {
        const response = await server.getSignList(sortBy.value, allSigns.value);
        items.value = response.result;
        filterSigns();
      } catch (err) {
        actions.showErrorSnackbar(
          'Error sorting signs. Please try again.',
          err as Error
        );
      } finally {
        loading.value = false;
      }
    };

    watch([sortBy, allSigns], getSigns);

    watch(search, _.debounce(filterSigns, 100), {
      immediate: false,
    });

    onMounted(async () => {
      await getSigns();
    });
    return {
      tableHeaders,
      filteredItems,
      items,
      loading,
      search,
      sortBy,
      sortByOptions,
      allSigns,
      getWidth,
      getSignHTMLCode,
    };
  },
});
